import { ReactNode } from "react"

type CardWrapperProps = {
  children: ReactNode
}
export const CardWrapper = ({ children }: CardWrapperProps) => {
  return (
    <div className="flex flex-col leading-7 text-l p-6 rounded-[8px] border border-[rgba(0,0,0,0.1)] dark:border-transparent bg-[rgba(212,212,212,0.1)] dark:bg-[rgba(255,255,255,0.04)] text-white backdrop-blur-md">
      {children}
    </div>
  )
}
